import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';

const styles = (theme) => ({});

const FormCheckbox = ({
    form,
    intl,
    formItemKey,
    initialValue,
    additionalRules = [],
    isRequired = false,
    color = 'primary',
    className = '',
    validateTrigger = 'onChange',
    disabled = false,
    onChange,
}) => {
    const { getFieldDecorator, getFieldValue } = form;

    const errors = form.getFieldError(formItemKey);
    return (
        <div id="yeself-form-checkbox">
            {getFieldDecorator(formItemKey, {
                initialValue: Boolean(initialValue),
                validateTrigger,
                preserve: true,
                rules: [
                    {
                        required: isRequired,
                        message: intl.formatMessage({ id: 'Form.field.isRequired' }),
                    },
                    ...(additionalRules && additionalRules.length > 0 ? additionalRules : []),
                ],
                    }
                )(
                    <Checkbox
                        className={className}
                        color={color}
                        checked={getFieldValue(formItemKey)}
                        disabled={disabled}
                        onChange={onChange}
                    />
                )
            }
        </div>
    );
};
export default withStyles(styles)(injectIntl(FormCheckbox));
